<template>
  <div class="p-4 md:p-6 space-y-4">
    <div class="flex items-center justify-between gap-3">
      <div>
        <h1 class="text-xl font-extrabold text-slate-800 text-left">Dashboard</h1>
        <p class="text-xs text-slate-500 text-left">Job moderation overview</p>
      </div>
      <button type="button" class="btn-primary" @click="$router.push({ name: 'jobs', query: { status: 'pending' } })">
        Review Pending
      </button>
    </div>

    <div v-if="loading" class="flex justify-center py-16">
      <div class="h-8 w-8 border-4 border-gray-300 border-t-[#0d4169] rounded-full animate-spin"></div>
    </div>

    <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
      <button
        v-for="card in cards"
        :key="card.key"
        type="button"
        class="h-[140px] rounded-2xl bg-white border border-slate-200 shadow-sm overflow-hidden border-t-4 border-t-[#0d4169] p-4 flex flex-col hover:bg-slate-50/80 transition"
        @click="card.onClick && card.onClick()"
      >
        <h2 class="text-base font-semibold text-slate-800 text-center">{{ card.title }}</h2>
        <div class="flex-1 flex items-center justify-center">
          <p class="text-3xl font-bold text-[#0d4169] tabular-nums">{{ card.value }}</p>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { apiFetch } from '../utils/api'

export default {
  name: 'DashboardView',
  setup() {
    const router = useRouter()
    const stats = ref({
      jobs: 0,
      pending: 0,
      published: 0,
      rejected: 0,
      applications: 0,
      users: 0,
    })
    const loading = ref(true)

    const cards = computed(() => [
      { key: 'pending', title: 'Pending Jobs', value: stats.value.pending, onClick: () => router.push({ name: 'jobs', query: { status: 'pending' } }) },
      { key: 'published', title: 'Published', value: stats.value.published, onClick: () => router.push({ name: 'jobs', query: { status: 'published' } }) },
      { key: 'rejected', title: 'Rejected', value: stats.value.rejected, onClick: () => router.push({ name: 'jobs', query: { status: 'rejected' } }) },
      { key: 'jobs', title: 'Total Jobs', value: stats.value.jobs, onClick: () => router.push({ name: 'jobs' }) },
      { key: 'applications', title: 'Applications', value: stats.value.applications },
      { key: 'users', title: 'Telegram Users', value: stats.value.users },
    ])

    async function load() {
      loading.value = true
      try {
        const res = await apiFetch('/admin/stats')
        const data = await res.json()
        stats.value = data.stats || stats.value
      } catch (err) {
        console.error(err)
      } finally {
        loading.value = false
      }
    }

    onMounted(load)
    return { cards, loading }
  },
}
</script>
